import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"


import { defineComponent, onMounted } from 'vue'
import MenuItemRender from './MenuItemRender.vue'
import store from '../store'
import { findTreeNode, MenuTree } from '../utils'
// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'HomePageLeftMenuRender'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

// const isCollapse = ref(true)
// eslint-disable-next-line
const handleOpen = (key: string, keyPath: string[]) => {
  // console.log('handleOpen ', key, keyPath)
}
// eslint-disable-next-line
const handleClose = (key: string, keyPath: string[]) => {
  // console.log('handleClose ', key, keyPath)
}
const handleSelect = (key: string, keyPath: string[]) => {
  // 添加展示页
  const result = findTreeNode(store.state.meunTree, key, '', 0)
  const menu = result?.node as MenuTree
  store.dispatch('addTab', { menuId: menu.id, targetName: menu.label, fullPath: result?.fullPath, url: menu.url, bindPage: menu.bindPage })
}
onMounted(async () => {
  console.log('HomePageLeftMenuRender onMounted store.state.leftMenuOpenedIds=', store.state.leftMenuOpenedIds)
})

return (_ctx: any,_cache: any) => {
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": "",
    class: "el-menu-vertical-demo",
    collapse: _unref(store).state.leftIsCollapse,
    onOpen: handleOpen,
    onClose: handleClose,
    onSelect: handleSelect,
    "default-openeds": _unref(store).state.leftMenuOpenedIds
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.leftMenu, (leftItem) => {
        return (_openBlock(), _createBlock(MenuItemRender, {
          item: leftItem,
          key: leftItem.id
        }, null, 8, ["item"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["collapse", "default-openeds"]))
}
}

})